import { render, staticRenderFns } from "./ProjectActionsContainerSimple.vue?vue&type=template&id=815210e0&scoped=true&"
var script = {}
import style0 from "./ProjectActionsContainerSimple.vue?vue&type=style&index=0&id=815210e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815210e0",
  null
  
)

export default component.exports